// extracted by mini-css-extract-plugin
export default {"banner":"UpdateBanner_banner__VtS2s","raised":"UpdateBanner_raised__KLtkf"};